(() => {
  async function addToCart(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (this.pending || !this.variant.available || !this.form.reportValidity()) return;
    this.pending=true;
    this.button.disabled=true;
    this.button.textContent=this.data.strings.adding;
    this.form.setAttribute('aria-busy','true');
    const status=this.querySelector('[data-ks-status]');
    status.hidden=true;
    const quantity=Math.max(1,Number.parseInt(this.form.querySelector('[name="quantity"]').value,10)||1);
    const items=[{id:this.variant.id,quantity}];
    const addon=this.querySelector('[data-ks-addon]');
    if(addon?.checked)items.push({id:Number(addon.dataset.variantId),quantity:Math.max(1,Number.parseInt(addon.dataset.quantity,10)||1)});
    try {
      const response=await fetch(this.data.addUrl,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
      const result=await response.json();
      if(!response.ok)throw new Error(typeof result.description==='string'?result.description:this.data.strings.error);
      status.dataset.error='false';
      status.textContent=this.data.strings.added+' ';
      const link=document.createElement('a');link.href=this.data.cartUrl;link.textContent=this.data.strings.cart;status.append(link);
      document.dispatchEvent(new CustomEvent('cart:open'));
    } catch(error) {
      status.dataset.error='true';status.textContent=error instanceof TypeError?this.data.strings.error:error.message;
    } finally {
      status.hidden=false;this.pending=false;this.form.removeAttribute('aria-busy');this.button.disabled=!this.variant.available;
      this.button.textContent=!this.variant.available?this.data.strings.soldOut:this.variant.backorder?this.data.strings.backorderAdd:this.data.strings.add;
    }
  }
  const setup = () => {
    document.querySelectorAll('.ks-handles-head').forEach(head => {
      if (head.dataset.handlesReady) return;
      const product = head.querySelector('ks-product');
      if (!product?.data) return;
      head.dataset.handlesReady = 'true';
      product.addToCart=addToCart;
      const axes = head.querySelector('[data-ks-handles-axes]');
      const data = axes ? JSON.parse(axes.querySelector('[data-ks-handles-variants]').textContent) : {variants:[]};
      const groups = axes ? [...axes.querySelectorAll('[data-ks-axis]')] : [];
      const current = () => data.variants.find(v => String(v.id) === product.input.value);
      const sync = () => {
        const variant = current();
        if (variant) groups.forEach((group, index) => {
          group.querySelector('[data-ks-axis-selection]').textContent = variant.options[index];
          group.querySelectorAll('[data-ks-choice]').forEach(button => {
            const value = button.dataset.ksChoice;
            const match = data.variants.find(v => v.options.every((option,i) => option === (i === index ? value : variant.options[i])));
            button.setAttribute('aria-pressed', String(variant.options[index] === value));
            button.disabled = !match;
            button.dataset.soldOut = String(!!match && !match.available);
            button.querySelector('[data-ks-choice-status]').textContent = !match ? data.unavailable : match.available ? '' : product.data.strings.soldOut;
          });
        });
        const story = head.parentElement.querySelector('.ks-handles-story');
        if (!story) return;
        const full = data.variants.find(v => String(v.id) === product.input.value);
        story.querySelectorAll('[data-ks-handles-mirror-price]').forEach(el => el.textContent = product.variant.price);
        if (full && head.dataset.productHandle === 'ez-rope') {
          ['rope-spec-thick','rope-spec-len','rope-spec-mat'].forEach((id,i) => {
            const el=story.querySelector('#'+id);if(el)el.textContent=full.options[i];
          });
        }
        if(full && head.dataset.productHandle==='popeyes') {
          const diameter=story.querySelector('#ppyh-spec-dia');if(diameter)diameter.textContent=full.options[0];
        }
      };
      axes?.addEventListener('click', event => {
        const button=event.target.closest('[data-ks-choice]');
        if (!button || button.disabled) return;
        const options=current()?.options.slice();if(!options)return;
        options[Number(button.closest('[data-ks-axis]').dataset.ksAxis)]=button.dataset.ksChoice;
        const variant=data.variants.find(v=>v.options.every((value,i)=>value===options[i]));
        if(variant)product.selectVariant(variant.id,true);
      });
      const quantity=head.querySelector('[data-ks-handles-quantity]');
      quantity?.addEventListener('input',()=> {
        product.form.querySelector('[name="quantity"]').value=String(Math.max(1,Math.floor(Number(quantity.value)||1)));
      });
      quantity?.addEventListener('change',()=>quantity.value=product.form.querySelector('[name="quantity"]').value);
      product.addEventListener('variant:change',sync);
      sync();
    });
    document.querySelectorAll('.ks-handles-story').forEach(story => {
      if(story.dataset.handlesReady)return;
      story.dataset.handlesReady='true';
      const head=story.parentElement.querySelector('.ks-handles-head');
      const product=head?.querySelector('ks-product');
      story.querySelectorAll('[data-ks-handles-top], [data-scroll-buybox], [data-nb2-scroll], a[href="#"], a[href="#top"]').forEach(button => {
        button.addEventListener('click',event=> {
          event.preventDefault();
          head?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
        });
      });
      story.querySelectorAll('.nb2-tab').forEach(tab => tab.addEventListener('click',()=> {
        story.querySelectorAll('.nb2-tab').forEach(other=>other.setAttribute('aria-selected',String(other===tab)));
        story.querySelectorAll('.nb2-panel').forEach(panel=>panel.toggleAttribute('data-active',panel.dataset.tab===tab.dataset.tab));
      }));
      story.querySelectorAll('[data-ks-handles-quick-variant]').forEach(button=>button.addEventListener('click',event=>{
        event.preventDefault();
        product?.selectVariant(button.dataset.ksHandlesQuickVariant,true);
        head?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      }));
    });
  };
  customElements.whenDefined('ks-product').then(setup);
  document.addEventListener('shopify:section:load',setup);
})();
